import { render, staticRenderFns } from "./Manage_feedback_answer_modules.vue?vue&type=template&id=67238f96&"
import script from "./Manage_feedback_answer_modules.vue?vue&type=script&lang=js&"
export * from "./Manage_feedback_answer_modules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports